import { composeStore } from 'owa-mail-compose-store';
import { lazyDiscardCompose, lazyLoadDraftToCompose } from 'owa-mail-compose-actions';
import { lazyNewMessage } from 'owa-mail-message-actions';
import selectFolderWithFallback from './selectFolderWithFallback';

export interface MailFolderRouteParameters {
    folderId?: string;
    draftId?: string;
}

export async function mailComposeNavigationRouteHandler(parameters: MailFolderRouteParameters) {
    // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
    // -> Error TS2345 (15,30): Argument of type 'string | undefined' is not assignable to parameter of type 'string'.
    // @ts-expect-error
    selectFolderWithFallback(parameters.folderId);

    if (parameters.draftId) {
        // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
        // -> Error TS2345 (21,75): Argument of type 'null' is not assignable to parameter of type 'string'.
        // @ts-expect-error
        await lazyLoadDraftToCompose.importAndExecute(parameters.draftId, null /* sxsId */);
    } else {
        await lazyNewMessage.importAndExecute('Route');
    }
}

export function mailComposeCleanupRouteHandler(): Promise<boolean> | boolean {
    if (composeStore.primaryComposeId) {
        return (
            lazyDiscardCompose
                // Strict mode was enabled in this package. See aka.ms/client-web-strict-mode for details.
                // -> Error TS2345 (34,31): Argument of type 'ComposeViewState | undefined' is not assignable to parameter of type 'ComposeViewState'.
                // @ts-expect-error
                .importAndExecute(composeStore.viewStates.get(composeStore.primaryComposeId))
                .then(
                    () => false, // Confirm ('Discard draft') means we should not block navigation
                    () => true
                )
        ); // Cancel ('Dont' discard') means we should block navigation
    } else {
        return false;
    }
}
